import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import parse, { attributesToProps, domToReact } from 'html-react-parser';

// Copa-Data Design Team told us to deactivate the animated BrandLogo
const inlineLogos = new Set([
//    '/brands/copadata/zenon_Online-Help_light.svg',
//    '/brands/copadata/zenon_Online-Help_darkmode.svg',
//    '/brands/straton/straton_Online-Help_light.svg',
//    '/brands/straton/straton_Online-Help_darkmode.svg',
]);

export default function BrandLogo({ src, alt, sx }) {
    const [svg, setSvg] = useState(null);

    useEffect(() => {
        if (!inlineLogos.has(src)) return;
        const controller = new AbortController();

        fetch(src, { signal: controller.signal })
            .then(response => {
                if (!response.ok) throw new Error('Logo could not be loaded');
                return response.text();
            })
            .then(markup => {
                if (!controller.signal.aborted) setSvg({ src, markup });
            })
            .catch(() => {
                // The image fallback remains visible if inline loading fails.
            });

        return () => controller.abort();
    }, [src]);

    if (inlineLogos.has(src) && svg?.src === src) {
        return parse(svg.markup, {
            replace(node) {
                if (node.name !== 'svg') return;
                return (
                    <Box {...attributesToProps(node.attribs)} component="svg" aria-label={alt} sx={sx}>
                        {domToReact(node.children)}
                    </Box>
                );
            },
        });
    }

    return <Box component="img" src={src} alt={alt} sx={sx} />;
}
